module.exports = __webpack_public_path__ + "img/skull_8.dd10f7f7.png";